import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-emerald-900 text-white relative overflow-hidden" data-id="element-299">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#10b981 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-300"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-301">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-302">
          <div className="inline-flex items-center justify-center p-3 bg-emerald-800 rounded-full mb-6" data-id="element-303">
            <Sparkles className="w-8 h-8 text-amber-400" data-id="element-304" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-305">
            El Método "Reset 72hs"
          </h2>

          <div className="bg-emerald-800/50 backdrop-blur-sm border border-emerald-700/50 rounded-2xl p-8 md:p-12 text-lg md:text-xl leading-relaxed text-emerald-50" data-id="element-306">
            <p className="mb-6" data-id="element-307">
              Este protocolo no cuenta calorías;{' '}
              <strong className="text-white font-bold" data-id="element-308">
                reprograma respuestas hormonales
              </strong>
              .
            </p>
            <p className="mb-6" data-id="element-309">
              A través de una selección estratégica de alimentos densos en
              minerales y grasas estables, "vaciamos" el glucógeno inflamatorio
              de tu cuerpo.
            </p>
            <p className="text-amber-300 font-medium text-xl md:text-2xl" data-id="element-310">
              En 3 días, la señal de alarma se apaga, el agua retenida se libera
              y tu metabolismo finalmente tiene permiso para usar tu grasa como
              energía.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}